import * as React from 'react'

import { TasksValueObjectsTaskIdentifierEnum } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import type Employee from 'modules/employees/store/models/Employee'
import EditTaskModal from 'modules/tasks/components/EditTaskModal'

import { TasksDataTable as TasksTable } from './DataTable'

interface Props {
  involveeId?: number
  identifier?: TasksValueObjectsTaskIdentifierEnum
  hideActions: boolean
  employee?: Employee
  isExternalUser: boolean
}

const TasksList = ({ involveeId, identifier, hideActions, employee, isExternalUser }: Props) => {
  const [taskId, setTaskId] = React.useState<number>()

  const onClose = () => {
    setTaskId(undefined)
  }

  return (
    <>
      <TasksTable
        involveeId={involveeId}
        onEdit={setTaskId}
        identifier={identifier}
        employee={employee}
        hideActions={hideActions}
        isExternalUser={isExternalUser}
      />
      {taskId && <EditTaskModal taskId={taskId} onClose={onClose} />}
    </>
  )
}

export default observer(TasksList)
